import { firestoreAction } from "vuexfire";
import "firebase/firestore";
import { db } from "@/services/firebase.service";

export default {
    addMoyenCommerciaux({ commit }, moyenCommerciaux) {
        commit("ADD_MOYEN_COMMERCIAUX", moyenCommerciaux);
    },

    putMoyenCommerciaux({ commit }, moyenCommerciaux) {
        commit("PUT_MOYENS_COMMERCIAUX", moyenCommerciaux);
    },

    SaveMoyenComm: firestoreAction(({ state, rootState, rootGetters }) => {
        db.collection("bpis")
            .doc(`${rootState.user.bpiId}`)
            .update({
                moyen_commerciaux: state.moyenCommerciaux,
                current_step: rootGetters["user/getLastStep"](
                    "Moyens fonciers et immeubles"
                )
            })
            .then(() => {});
    })
};
